<template>
    <div v-if="list.length">
        <component
            :is="href ? 'a' : 'u'"
            v-for="item in list"
            :key="item[trackKey]"
            :tag="href ? 'a' : 'u'"
            class="text-nowrap"
            :class="{ 'd-block': block }"
            :href="getUrl(href, item[trackKey])"
        >
            {{ item[trackLabel] }}
        </component>
    </div>

    <em
        v-else
        class="text-info"
        v-text="text"
    />
</template>

<script>
export default {
    props: {
        list: {
            type: Array,
            default: () => [],
        },
        emptyText: {
            type: String,
            default: '',
        },
        trackKey: {
            type: String,
            default: 'id',
        },
        trackLabel: {
            type: String,
            default: 'name',
        },
        block: {
            type: Boolean,
            default: false,
        },
        href: {
            type: String,
            default: '',
        },
    },
    methods: {
      getUrl(href, value) {
          if (href && href.match(/:id:/)) {
              return href.replace(':id:', value)
          } else if (href) {
              return href + value;
          } else {
              return undefined;
          }
      }
    },
    computed: {
        text() {
            return this.emptyText || this.$t('none');
        },
    },
};
</script>

<style scoped>
.text-nowrap:not(.d-block) {
    margin-right: 10px;
    display: inline-block;
}
</style>
